import React from "react";
import MisiKemanusiaanContent from "../../components/layouts/misi-internasional/MisiKemanusiaanContent";

const MisiKemanusiaan: React.FC = () => {
  return (
    <div>
      <MisiKemanusiaanContent />
    </div>
  );
};

export default MisiKemanusiaan;
